var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsHorizontalFill = function SvgDotsHorizontalFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 8.25a2.131 2.131 0 0 0 2.125-2.125A2.131 2.131 0 0 0 12.125 4 2.131 2.131 0 0 0 10 6.125c0 1.169.956 2.125 2.125 2.125Zm0 2.125A2.131 2.131 0 0 0 10 12.5c0 1.169.956 2.125 2.125 2.125A2.131 2.131 0 0 0 14.25 12.5a2.131 2.131 0 0 0-2.125-2.125Zm0 6.375A2.131 2.131 0 0 0 10 18.875c0 1.169.956 2.125 2.125 2.125a2.131 2.131 0 0 0 2.125-2.125 2.131 2.131 0 0 0-2.125-2.125Z",
    fill: "#FF5C7F"
  })));
};
export default SvgDotsHorizontalFill;